module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_guide-e92e0eacefd9d969be94e45b41c9ce8d.svg";